import React from 'react';

import loadTranslation from '../../utils/loadTranslation';
import Header from '../Header/Header';

const locale = 'en-us';

function HeaderPage() {
    return (
        <Header
            locale={locale}
            localeSwitcherVisible={false}
            path="https://www.wanderu.com"
            renderOffCanvasMenu={false}
            rootUrl="https://www.wanderu.com/"
            isExternal
            navLinksVisible
        />
    );
}

HeaderPage.serverFetchData = async function({ i18nCoordinator }) {
    await loadTranslation({ i18nCoordinator, locale, currency: 'USD' });
};

export default HeaderPage;
